import type { Nullable } from '@iheartjane/types';

import type { ProductSearchFilterCategory } from '@jane/bloom/viewModels/productSearchFilters';

// sort categories based on store custom product rankings
type GetCustomSortedCategories = {
  categories: ProductSearchFilterCategory[];
  productTypeRanking?: Nullable<string[]>;
};

export function getCustomSortedCategories({
  categories,
  productTypeRanking,
}: GetCustomSortedCategories) {
  const sortedCategories: ProductSearchFilterCategory[] = [];

  (productTypeRanking ?? []).forEach((rankedCategory) => {
    const foundCategory = categories.find(
      (category) =>
        category.value?.toLowerCase() === rankedCategory.toLowerCase() ||
        category.label?.toLowerCase() === rankedCategory.toLowerCase()
    );
    if (foundCategory) sortedCategories.push(foundCategory);
  });

  const remainingCategories = categories.filter(
    (category) => !sortedCategories.includes(category)
  );

  return [...sortedCategories, ...remainingCategories];
}
